<template>
  <div id="searchable-select">
    <v-autocomplete
      small-chips
      hide-selected
      v-model="selected"
      :autofocus="autocompleteOptions.autofocus"
      :clearable="autocompleteOptions.clearable"
      :hide-no-data="hide_no_data"
      :item-value="uniqueKey"
      :items="items"
      :label="autocompleteOptions.label"
      :loading="loading"
      :menu-props="{maxHeight: '300'}"
      :multiple="autocompleteOptions.multiple"
      :placeholder="autocompleteOptions.placeholder"
      :return-object="true"
      :search-input.sync="search"
      @blur="blurEvent"
      @change="changeEvent"
      @focus="focusEvent"
      :error-messages="errorMessage"
      :disabled="disabled !== undefined ? disabled : false"
    >
      <template v-slot:append-item>
        <div
          v-if="displayObserver"
          v-observe-visibility="{
            callback: visibilityChanged
          }"
          class="d-flex justify-center m-custom-loader"
        >
          <div><div class="c-autocomplete-loader"><v-icon>mdi-refresh-circle</v-icon></div></div>
        </div>
      </template>
      <!-- Add New Option -->
      <template v-slot:append-outer v-if="showAddNewModal">
        <v-icon small @click="openAddNewModal" color="#fff">mdi-plus</v-icon>
      </template>
    </v-autocomplete>
    <add-new-option
      v-if="showAddNewModal"
      :module="addNew.module"
      :isOpen="addNewModel"
      :title="addNew.title"
      @closeAddNew="addNewModel=false">
    </add-new-option>
    <!-- Add New Option Over -->
  </div>
</template>

<script>
import axios from 'axios'
const defaultObject = {
  url: undefined,
  label: '',
  placeholder: '',
  returnType: 'val',
  multiple: false,
  clearable: false,
  autofocus: false,
  data: undefined,
}
const CancelToken = axios.CancelToken
export default {
  props: ['options', 'errorMessage', 'selectedData', 'disabled', 'addNew'],
  beforeMount () {
    const finalObject = { ...defaultObject, ...this.options }
    if (this.options.placeholder === undefined) {
      finalObject.placeholder = `Select ${finalObject.label}`
    }
    this.autocompleteOptions = finalObject
    // Show add new option on attribue and right
    if (this.addNew !== undefined) {
      if (this.addNew && this.addNew.right !== undefined && this.addNew.right !== '') {
        this.showAddNewModal = this.$checkRight([this.addNew.right])
      } else {
        this.showAddNewModal = true
      }
    }
  },
  created () {
    this.getSelectedDataWatcher = this.$watch('selectedData', () => {
      const selectedData = this.autocompleteOptions.multiple === true ? (this.selectedData.length > 0 && this.selectedData[0].id !== undefined && this.selectedData[0].id !== null && this.selectedData[0].id !== '') : (this.selectedData.id !== undefined && this.selectedData.id !== null && this.selectedData.id !== '')
      if (selectedData) {
        this.items = this.autocompleteOptions.multiple === true ? this.selectedData : [this.selectedData]
        this.selected = this.selectedData
        this.syncDataInParent(this.selectedData)
        this.getSelectedDataWatcher()
      }
    })
  },
  data: function () {
    return {
      loading: false,
      displayObserver: true,
      page: 1,
      items: [],
      search: '',
      selected: [],
      uniqueKey: 'id',
      hide_no_data: true,
      autocompleteOptions: {},
      addNewModel: false,
      showAddNewModal: false
    }
  },
  watch: {
    search (val) {
      val && val !== this.selected && this.callRequestDebounced()
    },
  },
  methods: {
    callRequestDebounced () {
      this.blurEvent()
      this.loading = true
      clearTimeout(this._callRequestDebounced)
      this._callRequestDebounced = setTimeout(() => {
        this.callRequest()
      }, 500)
    },
    focusEvent () {
      if (this.page === 1) {
        this.callRequest()
      }
    },
    callRequest () {
      this.loading = true
      if (this.requestCancel !== undefined) {
        this.requestCancel()
      }
      const data = {}
      if (this.autocompleteOptions.data !== undefined) {
        data.data = this.autocompleteOptions.data
      }
      this.$axios
        .post(
          `getSuggestion/${this.autocompleteOptions.url}`,
          { page: this.page, page_limit: 10, str: this.search, ...data },
          {
            mainLoader: false,
            requestForSearchable: true,
            cancelToken: new CancelToken((c) => {
              this.requestCancel = c
            }),
          }
        )
        .then((res) => {
          this.items = [...this.items, ...res.data.data]
          this.loading = false
          if (res.data.next_page_url === null) {
            this.displayObserver = false
          } else {
            this.page++
          }
          if (this.items.length === 0) {
            this.hide_no_data = false
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    visibilityChanged (e) {
      if (e) {
        this.callRequest()
      }
    },
    blurEvent () {
      if (this.autocompleteOptions.multiple === true) {
        this.items = this.selected.length > 0 ? this.selected : []
      } else {
        this.items = this.selected && !!this.selected.id ? [this.selected] : []
      }
      this.page = 1
      this.hide_no_data = true
    },
    changeEvent () {
      const selected = this.selected ? JSON.parse(JSON.stringify(this.selected)) : ''
      if (selected && selected !== '') {
        if (this.getSelectedDataWatcher !== undefined) {
          this.getSelectedDataWatcher()
        }
        this.syncDataInParent(selected)
      } else {
        this.$emit('update:value', selected)
      }
    },
    syncDataInParent (selected) {
      if (this.autocompleteOptions.returnType === 'object') {
        this.$emit('update:value', selected)
      } else if (this.autocompleteOptions.multiple === true && this.autocompleteOptions.returnType !== 'object') {
        this.$emit('update:value', selected.map((e) => {
          return e.id
        }))
      } else {
        this.$emit('update:value', selected.id)
      }
    },
    openAddNewModal () {
      this.addNewModel = true
    }
  },
}
</script>
<style lang="scss">
#searchable-select {
  .v-select.v-text-field input {
    min-height: 32px !important;
  }
}
.m-custom-loader {
  height: 30px
}
.c-autocomplete-loader {
  -webkit-animation: infiniteRotate 2s linear infinite;
  -moz-animation: infiniteRotate 2s linear infinite;
  -o-animation: infiniteRotate 2s linear infinite;
  animation: infiniteRotate 2s linear infinite;
}
@-webkit-keyframes infiniteRotate {
  from { -webkit-transform: rotate(0deg)}
  to   { -webkit-transform: rotate(360deg)}
}
@-moz-keyframes infiniteRotate {
  from { -moz-transform: rotate(0deg)}
  to   { -moz-transform: rotate(360deg)}
}
@-o-keyframes infiniteRotate {
  from { -o-transform: rotate(0deg)}
  to   { -o-transform: rotate(360deg)}
}
@keyframes infiniteRotate {
  from { transform: rotate(0deg)}
  to   { transform: rotate(360deg)}
}
.v-input__append-outer {
  display: flex;
  height: 25px;
  width: 30px;
  align-items: center;
  justify-content: center;
  background: #464c69;
}
.v-input__append-outer .v-icon, .v-input__prepend-outer .v-icon {
  font-size: 15px;
}
.v-application--is-ltr .v-input__append-outer {
  margin-left: 2px;
  margin-top: 8px;
}
</style>
